<template>
	<section>
		<!--工具条-->
		<div :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters" size="mini">
				<el-form-item label="项目名称">
					<el-select v-model="filters.projectId" filterable>
						<el-option
							v-for="item in projects"
							:label="item.name"
							:value="item.projectId" :key="item.projectId">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="时间">
					<el-date-picker type="date" v-model="filters.date" style="width: 100%;"></el-date-picker>
                </el-form-item>
				<el-form-item>
					<create-form-button  @select-type="bornForm" ></create-form-button>
					<download-form-button    @select-type="clickBtn" ></download-form-button>
				</el-form-item>
			</el-form>
		</div>

		<div id="formCon"  v-loading="loading"   element-loading-text="报表生成中"  element-loading-spinner="el-icon-loading"  element-loading-background="rgba(0, 0, 0, 0.8)">
			<div id="title">
				<div class="title1"><span>{{projectName}}功能区声环境质量分析报告</span></div>
				<div class="title3"><span> {{date1}}噪声日报</span></div>
				<div class="title2">
					<!-- <span class="span1">安徽科创中光科技有限公司</span> -->
					<!-- <span class="span2"> {{date2}}</span> -->
				</div>
			</div>
			<div id="con1">
				<div class="contitle">1.噪声质量情况</div>
				<p class="condes">
					<span>{{date1}}，{{projectName}}</span
					><span>各类功能区昼间总点次达标为{{ldTotalRate}}%，夜间总点次达标率为{{lnTotalRate}}%。总体来看，全市城市功能区声环境质量昼间点次达标率{{levelStr}}夜间。</span>
				</p>
				<p class="condes">
					<span v-if="ldOutLimitSite!=''">全市昼间噪声超标点位有：{{ldOutLimitSite}}。</span
					><span v-if="lnOutLimitSite!=''">全市夜间噪声超标点位有: {{lnOutLimitSite}}。</span>
				</p>
			</div>
			<div id="con2">
				<div class="contitle">2.噪声数据分析</div>
				<div class="contitle">2.1各功能区达标率统计</div>
				<p class="condes">
					<span>{{date1}}，</span
					><span>昼间总点次达标为{{ldTotalRate}}%，夜间总点次达标率为{{lnTotalRate}}%。各功能区昼间/夜间达标率如下：</span>
				</p>
				<div id="con2add"></div>
			</div>
			<div id="con3">
				<div class="contitle">2.2 各个点位数据统计</div>
				<p class="condes">
					<span v-if="ldOutLimitSite!=''">全市昼间噪声超标点位有：{{ldOutLimitSite}}。</span
					><span v-if="lnOutLimitSite!=''">全市夜间噪声超标点位有: {{lnOutLimitSite}}。</span>
				</p>
				<div id="con3add"></div>
			</div>
			<div id="con4">
				<div class="contitle">2.3 超标原因分析</div>
				<div id="con4add"></div>
			</div>
			<div id="con5">
				<div class="contitle">2.4 各点位噪声值及环比分析</div>
				<div id="con5add"></div>
			</div>
			<div id="con6">
				<div class="contitle">3.达标率统计</div>
				<div id="con6add"></div>
			</div>
		</div>

	</section>
</template>

<script>
	import * as echarts from "echarts";
	import {getProjects,generateForDay,getFunctionalAreaList } from '../../api/api.js';
	import {formatDateForm1,formatDateForm2,formatDate3} from '../../../static/fun.js';
	import {handleWindowPrint,drawEchartImg,initContent,deleteImg} from '../../../static/print.js';


	import CreateFormButton from '../../components/myButton/CreateFormButton.vue'
	import DownloadFormButton from '../../components/myButton/DownloadFormButton.vue'

	export default {
	components: { DownloadFormButton,CreateFormButton },
		data() {
			return {
				filters: {
					projectId: '',
					date:''
				},
				projects:[],
				projectName:'',

				date1:'',
				date2:'',
				picArr:[],
				loading:false,
				chooseNames:[],
				functionalAreaMap:new Map(),
				lnTotalRate:100,//夜间总点次达标率
				lnOutLimitSite:"",//夜间噪声超标点位
				ldTotalRate:100,
				ldOutLimitSite:"",
				levelStr:"等于",
				timeList:[],
				nightInitialTime:22,
				diurnalInitialTime:6
			}
			
		},
		methods: {
			getFunctionalAreaList(){
				getFunctionalAreaList({}).then((res) => {
                    res.data.data.forEach(element => {
						this.functionalAreaMap.set(element.id,element);
					});
                    this.getProjects();
				});
			},
			clickBtn(type){
				if(type=="pdf"){
					this.exportPDF();
				}else if(type=="word"){
					this.exportWord();
				}
			},
			//查询项目信息
			getProjects() {
				this.listLoading = true;
				getProjects().then((res) => {
					
					this.projects = res.data.data;
					this.listLoading = false;
					if(this.projects.length>0){
						this.filters.projectId=this.projects[0].projectId;
						this.projectName=this.projects[0].name;
					}

				});
			},
			bornForm(){
				this.loading=true;
				this.getProjectName();
				this.getDate();
				var param={
					projectId:this.filters.projectId,
					date:formatDate3(this.filters.date)
				}
				generateForDay(param).then((res) => {
					this.loading=false;
					if(res.data.code!=200){
						this.$message({
							message: "查询失败，请重试",
							type: 'error'
						})
						return;
					}

					this.picArr=[];
					var resData=res.data.data;

					//调整限值  对设备进行根据功能区分组
					var functionalAreaGroup=[];
					var funid=0;
					var functionalAreaNow=[];
					for (let index = 0; index < resData.siteStat.length; index++) {
						const element = resData.siteStat[index];
						var functionArea=this.functionalAreaMap.get(element.functionalAreaId);
						element.functionAreaName=functionArea.name;
						element.ldLimit=functionArea.day;
						element.lnLimit=functionArea.night;
						//判断是否超标
						if(element.ld=="-"){
							element.ldLimitFlag=-1;
						}
						else if(element.ldLimit<element.ld){
							element.ldLimitFlag=1;
						}else{
							element.ldLimitFlag=0;
						}

						if(element.ln=="-"){
							element.lnLimitFlag=-1;
						}
						else if(element.lnLimit<element.ln){
							element.lnLimitFlag=1;
						}else{
							element.lnLimitFlag=0;
						}

						//第一条
						if(funid==0){
							funid=element.functionalAreaId;
						}
						//新的功能区
						else if(element.functionalAreaId!=funid){
							functionalAreaGroup.push(functionalAreaNow);
							functionalAreaNow=[];
							funid=element.functionalAreaId;
						}
						functionalAreaNow.push(element);

					}
					//最后一条
					functionalAreaGroup.push(functionalAreaNow);

					//部分数据赋值
					this.assignValue(resData);
					//2.1 各功能区达标率统计
					this.initRateData(resData);
					//2.2 各个点位数据统计
					this.initSiteData(resData);
					//2.3 超标原因分析
					this.initReasonData(resData);
					//2.4 各点位噪声值及环比分析
					this.initCirData(functionalAreaGroup);
					// 3.达标率统计
					this.initRateStatData(resData);
				
				});
			},
			initCirData(functionalAreaGroup){
				//先删除上次生成标签
				var body = document.getElementById('con5add');
				body.innerHTML='';
				var j=0;
				functionalAreaGroup.forEach(element => {
					var str="";
					j++;
					str+="<p class='condes'>（"+j+"）"+element[0].functionAreaName+"功能区</p>";

					var div = document.createElement('div');
					div.className="con3div";
					str+='<table class="table-wrap" border="1" cellspacing="0" cellpadding="0">'
						+'<thead>'
							+'<tr>'
								+'<td rowspan="2">序号</td>'
								+'<td rowspan="2">点位名称</td>'
								+'<td rowspan="2">功能区类别</td>'
								+'<td colspan="3">Ld(dB)</td>'
								+'<td colspan="3">Ln(dB)</td>'
							+'</tr>'
							+'<tr>'
								+'<td>今天</td>'
								+'<td>昨天</td>'
								+'<td>环比率(%)</td>'
								+'<td>今天</td>'
								+'<td>昨天</td>'
								+'<td>环比率(%)</td>'
							+'</tr>'
						+'</thead>'
						+'<tbody>';
						var i=1;
						element.forEach(ele => {
							str+='<tr>'
								+'<td>'+i+'</td>'
								+'<td >'+ele.deviceName+'</td>'
								+'<td>'+ele.functionAreaName+'</td>'
								+'<td>'+ele.ld+'</td>'
								+'<td>'+ele.ldYesterday+'</td>'
								+'<td>'+ele.ldRate+'</td>'
								+'<td>'+ele.ln+'</td>'
								+'<td>'+ele.lnYesterday+'</td>'
								+'<td>'+ele.lnRate+'</td>'
								+'</tr>';
							i++;
						});
						str+='</tbody>';
					str+='</table>';
					div.innerHTML=str;
					body.appendChild(div);
					this.initChartdetail(element);
				})

			},
			initRateData(resData){
				//先删除上次生成标签
				var body = document.getElementById('con2add');
				body.innerHTML='';
				var div = document.createElement('div');
				div.className="con3div";

				var str='<table class="table-wrap" border="1" cellspacing="0" cellpadding="0">'
					+'<thead>'
						+'<tr>'
							+'<td rowspan="2">序号</td>'
							+'<td rowspan="2">功能区类别</td>'
							+'<td rowspan="2">点位数</td>'
							+'<td colspan="2">昼间</td>'
							+'<td colspan="2">夜间</td>'
						+'</tr>'
						+'<tr>'
							+'<td>达标数</td>'
							+'<td>达标率</td>'
							+'<td>达标数</td>'
							+'<td>达标率</td>'
						+'</tr>'
					+'</thead>'
					+'<tbody>';
					var i=1;
					var dataList=resData.functionalAreaStat;
					dataList.forEach(ele => {
						str+='<tr>'
							+'<td>'+i+'</td>'
							+'<td >'+ele.functionalAreaName+'</td>'
							+'<td>'+ele.countSite+'</td>'
							+'<td>'+ele.ldSite+'</td>'
							+'<td>'+ele.ldRate+'%</td>'
							+'<td>'+ele.lnSite+'</td>'
							+'<td>'+ele.lnRate+'%</td>'
							+'</tr>';
						i++;
					});
					str+='</tbody>';
				str+='</table>';
				div.innerHTML=str;
				body.appendChild(div);
			
			},
			initSiteData(resData){
				//先删除上次生成标签
				var body = document.getElementById('con3add');
				body.innerHTML='';
				var div = document.createElement('div');
				div.className="con3div";

				var str='<table class="table-wrap" border="1" cellspacing="0" cellpadding="0">'
					+'<thead>'
						+'<tr>'
							+'<td rowspan="2">序号</td>'
							+'<td rowspan="2">功能区类别</td>'
							+'<td rowspan="2">点位名称</td>'
							+'<td colspan="3">昼间</td>'
							+'<td colspan="3">夜间</td>'
						+'</tr>'
						+'<tr>'
							+'<td>限值(dB)</td>'
							+'<td>Ld(dB)</td>'
							+'<td>结论</td>'
							+'<td>限值(dB)</td>'
							+'<td>Ln(dB)</td>'
							+'<td>结论</td>'
						+'</tr>'
					+'</thead>'
					+'<tbody>';
					var i=1;
					var dataList=resData.siteStat;
					dataList.forEach(ele => {
						str+='<tr>'
							+'<td>'+i+'</td>'
							+'<td >'+ele.functionAreaName+'</td>'
							+'<td>'+ele.deviceName+'</td>'

							+'<td>'+ele.ldLimit+'</td>';
							//超标
							if(ele.ldLimitFlag==1){
								str+='<td class="red">'+ele.ld+'</td>';
								str+='<td class="red">超标</td>';
							}else if(ele.ldLimitFlag==0){
								str+='<td >'+ele.ld+'</td>';
								str+='<td >正常</td>';
							}else{
								str+='<td >'+ele.ld+'</td>';
								str+='<td >-</td>';
							}

								str+='<td>'+ele.lnLimit+'</td>'
							//超标
							if(ele.lnLimitFlag==1){
								str+='<td class="red">'+ele.ln+'</td>';
								str+='<td class="red">超标</td>';
							}else if(ele.lnLimitFlag==0){
								str+='<td >'+ele.ln+'</td>';
								str+='<td >正常</td>';
							}else{
								str+='<td >'+ele.ln+'</td>';
								str+='<td >-</td>';
							}

							+'</tr>';
						i++;
					});
					str+='</tbody>';
				str+='</table>';
				div.innerHTML=str;
				body.appendChild(div);
			
			},
			initReasonData(resData){
				//先删除上次生成标签
				var body = document.getElementById('con4add');
				body.innerHTML='';
				var div = document.createElement('div');
				div.className="con3div";

				var str='<table class="table-wrap" border="1" cellspacing="0" cellpadding="0">'
					+'<thead>'
						+'<tr>'
							+'<td>序号</td>'
							+'<td>超标点位</td>'
							+'<td>超标阈值（dB）</td>'
							+'<td>超标时间点</td>'
							+'<td>超标数值</td>'
							+'<td>超标原因</td>'
						+'</tr>'
					+'</thead>'
					+'<tbody>';
					var i=1;
					var dataList=resData.reason;
					dataList.forEach(ele => {
						var count=ele.data.length;
						str+='<tr>'
							+'<td rowspan='+count+'>'+i+'</td>'
							+'<td rowspan='+count+'>'+ele.deviceName+'</td>'

							var element = ele.data[0];
							str+='<td>'+element.limit+'</td>'
							str+='<td>'+element.time+'</td>'
							str+='<td>'+element.value+'</td>'
							str+='<td rowspan='+count+'></td>'
						str+='</tr>';

						for (let index = 1; index < count; index++) {
							str+='<tr>';
							element = ele.data[index];
							str+='<td>'+element.limit+'</td>'
							str+='<td>'+element.time+'</td>'
							str+='<td>'+element.value+'</td>'
							str+='</tr>';
						}
						i++;
					});
					str+='</tbody>';
				str+='</table>';
				div.innerHTML=str;
				body.appendChild(div);
			
			},
			initRateStatData(resData){
				//先删除上次生成标签
				var body = document.getElementById('con6add');
				body.innerHTML='';
				var div = document.createElement('div');
				div.className="con3div";

				var str='<table class="table-wrap" border="1" cellspacing="0" cellpadding="0">'
					+'<thead>'
						+'<tr>'
							+'<td rowspan="2">时间</td>'
							+'<td colspan="2">达标率</td>'
						+'</tr>'
						+'<tr>'
							+'<td>昼间</td>'
							+'<td>夜间</td>'
						+'</tr>'
					+'</thead>'
					+'<tbody>';
					var i=1;
					var dataList=resData.rateStat;
					dataList.forEach(ele => {
						str+='<tr>'
							+'<td >'+ele.name+'</td>'
							+'<td>'+ele.ld+'%</td>'
							+'<td>'+ele.ln+'%</td>'
							+'</tr>';
						i++;
					});
					str+='</tbody>';
				str+='</table>';
				div.innerHTML=str;
				body.appendChild(div);
			
			},
			initChartdetail(siteGroup){
				this.chooseNames=[];
				var seriesDataAll=[];
				var funid=0;
				var ldLimit=0;
				var lnLimit=0;

				var i=0;
				siteGroup.forEach(element => {
					let deviceOne={};
					deviceOne.type='line';
					deviceOne.name=element.deviceName;
					deviceOne.connectNulls=false;//null中断
					deviceOne.data=element.hourDataList;
					seriesDataAll.push(deviceOne);
					this.chooseNames.push(element.deviceName);

					if(i==0){
						funid=element.functionalAreaId;
						ldLimit=element.ldLimit;
						lnLimit=element.lnLimit
					}
					
					i++;
				});

				var limiteData1=[];
				var limiteData2=[];
				//先昼16 后夜8
				for (let index = 0; index < 16; index++) {
					limiteData1.push(ldLimit);
					limiteData2.push("-");
				}
				limiteData1.push(ldLimit);
				limiteData2.push(lnLimit);
				for (let index = 0; index < 7; index++) {
					limiteData1.push("-");
					limiteData2.push(lnLimit);
				}

				let deviceOne={
					type:"line",
					data:limiteData1,
					lineStyle: {
						color: '#F00',
						width: 4,
						type: 'dashed'
					}
				}
				seriesDataAll.push(deviceOne);
				deviceOne={
					type:"line",
					data:limiteData2,
					lineStyle: {
						color: '#F00',
						width: 4,
						type: 'dashed'
					}
				}
				seriesDataAll.push(deviceOne);

				var div = document.createElement('div');
				div.id="chartfun"+funid;
				div.className="chartDiv2 con3div";
				var body = document.getElementById('con5add');
				body.appendChild(div);
				this.drawLineChart(seriesDataAll,"chartfun"+funid); 
				var div2 = document.createElement('div');
				div2.id="chartfun"+funid+"img";
				div2.className="con3div";
				body.appendChild(div2);
				this.picArr.push("chartfun"+funid);
			},
			assignValue(resData){
				this.lnTotalRate=resData.lnTotalRate;
				this.lnOutLimitSite=resData.lnOutLimitSite;
				this.ldTotalRate=resData.ldTotalRate;
				this.ldOutLimitSite=resData.ldOutLimitSite;
				if(this.ldTotalRate>this.lnTotalRate){
					this.levelStr="高于";
				}else if(this.ldTotalRate<this.lnTotalRate){
					this.levelStr="低于";
				}else{
					this.levelStr="等于";
				}
				this.timeList=resData.timeList;
				this.nightInitialTime=resData.nightInitialTime;
				this.diurnalInitialTime=resData.diurnalInitialTime;
			},
			drawLineChart:function(seriesData,id) {
				var lgdStyle={
					top:40,
					itemWidth: 10,  // 设置宽度
					itemHeight: 10, // 设置高度
					x:'right'
				};
				
               	var chart = echarts.init(document.getElementById(id));
                chart.setOption({
					backgroundColor: '#fff',
                    toolbox: {
                        show : true
                    },
                    legend: lgdStyle,
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        top:80,
                        containLabel: true
                    },
                    xAxis: {
                        boundaryGap: true,
						data:this.timeList,
                    },
                    yAxis: {
						type: 'value',
						scale: true
                    },
                    series:seriesData
            	},true);
            },
			exportPDF(){
				var flag=handleWindowPrint('#formCon',this.picArr);
				if(!flag){
					this.$message({
						message: "导出日报出错，请重试",
						type: 'error'
					})
				}
			},
			exportWord(){
				if(drawEchartImg(this.picArr)){
					var content=initContent('#formCon');

					var converted = htmlDocx.asBlob(content);
					saveAs(converted, this.projectName+"_"+this.date1+'.docx');
					deleteImg(this.picArr);

					return;
					// var blob = new Blob([content], {
					// 	type:"application/msword;charset=utf-8"
					// }); 
					// var downloadElement = document.createElement("a");
					// var href = window.URL.createObjectURL(blob); //创建下载的链接
					// downloadElement.href = href;
					// downloadElement.download = this.projectName+"_"+this.date1+""; //下载后文件名
					// document.body.appendChild(downloadElement);
					// downloadElement.click(); //点击下载
					// document.body.removeChild(downloadElement); //下载完成移除元素
					// window.URL.revokeObjectURL(href); //释放掉blob对象
					// deleteImg(this.picArr);
					// return;
				}
			},
			getProjectName(){
				 this.projects.forEach(item => {
					if(this.filters.projectId==item.projectId){
						this.projectName=item.name;
						return;
					}
				});
			},
			getDate(){
				this.date1=formatDateForm1(this.filters.date);
				this.date2=formatDateForm2(this.filters.date);
			},
		},
		mounted() {
			this.getProjects();
			this.getFunctionalAreaList();
			//time设为昨天
			var date = new Date();
			this.filters.date=date.getTime() - 3600 * 1000 * 24;
			this.getDate();
		}
	}

</script>

<style>
	@import 'form.css';

	#con6add{
		margin-bottom: 20px;
	}
</style>


// WEBPACK FOOTER //
// dayStat.vue?40c2afe2